export type FieldTypes = {
  array: React.ComponentType<any>
  blocks: React.ComponentType<any>
  checkbox: React.ComponentType<any>
  code: React.ComponentType<any>
  collapsible: React.ComponentType<any>
  confirmPassword: React.ComponentType<any>
  date: React.ComponentType<any>
  email: React.ComponentType<any>
  group: React.ComponentType<any>
  hidden: React.ComponentType<any>
  json: React.ComponentType<any>
  number: React.ComponentType<any>
  password: React.ComponentType<any>
  point: React.ComponentType<any>
  radio: React.ComponentType<any>
  relationship: React.ComponentType<any>
  richText: React.ComponentType<any>
  row: React.ComponentType<any>
  select: React.ComponentType<any>
  tabs: React.ComponentType<any>
  text: React.ComponentType<any>
  textarea: React.ComponentType<any>
  ui: React.ComponentType<any>
  upload: React.ComponentType<any>
}
